"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Direction = exports.OrderBy = exports.ActivityActionType = exports.ActivityObjectType = exports.LoginType = exports.protobufPackage = void 0;
exports.protobufPackage = 'manUser';
var LoginType;
(function (LoginType) {
    LoginType[LoginType["CREDENTIALS"] = 0] = "CREDENTIALS";
    LoginType[LoginType["TOKEN"] = 1] = "TOKEN";
    LoginType[LoginType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LoginType = exports.LoginType || (exports.LoginType = {}));
var ActivityObjectType;
(function (ActivityObjectType) {
    ActivityObjectType[ActivityObjectType["COMMENT"] = 0] = "COMMENT";
    ActivityObjectType[ActivityObjectType["GALLERY"] = 1] = "GALLERY";
    ActivityObjectType[ActivityObjectType["MODEL"] = 2] = "MODEL";
    ActivityObjectType[ActivityObjectType["PHOTOGRAPHER"] = 3] = "PHOTOGRAPHER";
    ActivityObjectType[ActivityObjectType["SITE"] = 4] = "SITE";
    ActivityObjectType[ActivityObjectType["USER"] = 5] = "USER";
    ActivityObjectType[ActivityObjectType["MEDIA"] = 6] = "MEDIA";
    ActivityObjectType[ActivityObjectType["BLOG"] = 7] = "BLOG";
    ActivityObjectType[ActivityObjectType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ActivityObjectType = exports.ActivityObjectType || (exports.ActivityObjectType = {}));
var ActivityActionType;
(function (ActivityActionType) {
    ActivityActionType[ActivityActionType["COMMENT"] = 0] = "COMMENT";
    ActivityActionType[ActivityActionType["FAVORITE"] = 1] = "FAVORITE";
    ActivityActionType[ActivityActionType["FOLLOW"] = 2] = "FOLLOW";
    ActivityActionType[ActivityActionType["RATE"] = 3] = "RATE";
    ActivityActionType[ActivityActionType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ActivityActionType = exports.ActivityActionType || (exports.ActivityActionType = {}));
var OrderBy;
(function (OrderBy) {
    OrderBy[OrderBy["TIMESTAMP"] = 0] = "TIMESTAMP";
    OrderBy[OrderBy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(OrderBy = exports.OrderBy || (exports.OrderBy = {}));
var Direction;
(function (Direction) {
    Direction[Direction["DESC"] = 0] = "DESC";
    Direction[Direction["ASC"] = 1] = "ASC";
    Direction[Direction["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Direction = exports.Direction || (exports.Direction = {}));
